<template>
  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3332 1.66602C10.2286 1.66602 9.33319 2.56145 9.33319 3.66602V4.00743C7.0028 4.8311 5.33319 7.05358 5.33319 9.66602V14.666L3.85142 16.8887C3.6299 17.2209 3.8681 17.666 4.26745 17.666H18.3989C18.7983 17.666 19.0365 17.2209 18.815 16.8887L17.3332 14.666V9.66602C17.3332 7.05358 15.6636 4.8311 13.3332 4.00743V3.66602C13.3332 2.56145 12.4378 1.66602 11.3332 1.66602ZM11.3333 21.666C12.8205 21.666 14.0549 20.5838 14.2921 19.1639C14.3376 18.8916 14.1094 18.666 13.8333 18.666H8.83325C8.55711 18.666 8.32888 18.8916 8.37438 19.1639C8.61156 20.5838 9.84602 21.666 11.3333 21.666Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Bell',
};
</script>
